import React from "react"

export default function Emoji(props) {
	const path = `/emojis/${props.name}.png`

	return <img alt={props.name} className="emoji" src={path} />
}
